import { createAction, props } from '@ngrx/store';
import { AtlasEvents } from '@fund-base/types/atlas-events/atlas-events.types';
import { AtlasNews } from '@fund-base/types/atlas-news/atlas-news.types';

export const setAtlasEvents = createAction('[Atlas-Data] Set Atlas Events', props<{ atlasEvents?: AtlasEvents[] }>());

export const setAtlasNews = createAction('[Atlas-Data] Set Atlas News', props<{ atlasNews?: AtlasNews[] }>());
